// RadioSelectionInput
// You need this component when you want to sync both *** RADIO and INPUT ***
// eg. radioSelectionInput(:radioValue.sync="type", :inputValue.sync="value")

<template lang="pug">
  div.group-horizontal.area
    el-col(:span="10")
      el-radio(:label="label", v-model="radio", @change="selectRadio")
        slot
    el-col(v-if="showInput", :span="14")
      el-input(
        :placeholder="placeHolder",
        :disabled="isDisable",
        v-model="input",
        @change="changeInput",
        :style="styleVal",
        :prop="prop",
      )
</template>

<style lang="scss" scoped>
.row {
  display: flex;
  justify-content: space-between;
}
.text {
  color: #606266;
  font-size: 18px;
  font-weight: 400;
  line-height: 2.2;
}
.radio {
  margin-top: 12px;
  margin-left: 0px;
  font-size: 16px;
}

.group-horizontal {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  &.radio-input {
    margin-top: 5px;
    height: 30px;
  }
  &.area {
    width: 400px;
    height: 50px;
  }
}
</style>

<script>
export default {
  name: 'radioSelectionInput',
  props: {
    radioValue: [String, Number, Boolean],
    inputValue: [String, Number],
    placeHolder: String,
    label: {
      type: [String, Boolean],
      required: true,
    },
    showInput: {
      type: Boolean,
      default: true,
      required: false,
    },
    prop: {
      type: String,
      required: false,
    },
    default: {
      type: [String, Number],
      required: false,
    },
    styleVal: {
      type: String,
      default: 'margin-top: -10px;',
      required: false,
    },
  },
  data () {
    return {
      input: '',
      radio: '',
      isDisable: true,
    }
  },
  mounted () {
    this.radio = this.radioValue
  },
  watch: {
    radioValue (val) {
      if (val !== this.label) {
        this.isDisable = true
      } else {
        this.isDisable = false
      }
      this.radio = val
    },
    inputValue (val) {
      if (this.isDisable) {
        return
      }
      this.input = val
    },
  },
  methods: {
    changeInput (value) {
      this.$emit('update:inputValue', this.input)
    },
    selectRadio (value) {
      if (this.input === '' || this.input === 0 || this.input === null) {
        this.input = this.$props.default || ''
      }
      this.$emit('update:inputValue', this.input)
      this.$emit('update:radioValue', this.label)
    },
  },
}
</script>
